import moment from "moment";

export const mixins = {
  methods: {
    format_date(value) {
      if (value) {
        return moment(String(value)).format("DD / MM / YYYY");
      }
    },
    logout: function() {
      this.$store.dispatch("logOut");
      localStorage.removeItem("access_token");
      window.dispatchEvent(new CustomEvent("setUsername"));
      this.$router.push("/");
    }
  }
};
